import { render } from "./Prompt.vue?vue&type=template&id=6084a6da&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"

import "./Prompt.vue?vue&type=style&index=0&id=6084a6da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6084a6da"]])

export default __exports__